import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/service/auth.service';
import { KeycloakService } from 'keycloak-angular';

/**
 * Component that redirects users to the appropriate dashboard based on their role.
 * - Admin users are redirected to /admin/dashboard
 * - All other roles are redirected to /enterprise/dashboard
 */
@Component({
  selector: 'app-role-redirect',
  standalone: true,
  template: `
    <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  `,
})
export class RoleRedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService,
    private keycloakService: KeycloakService
  ) {}

  ngOnInit(): void {
    this.redirectBasedOnRole();
  }

  private redirectBasedOnRole(): void {
    // Debug: Get all info about roles
    const userRoles = this.keycloakService.getUserRoles();
    const realmRoles = this.keycloakService.getUserRoles(true); // Include realm roles
    const keycloakInstance = this.keycloakService.getKeycloakInstance();
    
    console.log('RoleRedirect - getUserRoles():', userRoles);
    console.log('RoleRedirect - getUserRoles(true):', realmRoles);
    console.log('RoleRedirect - Token parsed:', keycloakInstance?.tokenParsed);
    console.log('RoleRedirect - realm_access:', keycloakInstance?.tokenParsed?.realm_access);
    console.log('RoleRedirect - isAdmin():', this.authService.isAdmin());

    // Check if user is super admin
    const isSuperAdmin = this.authService.isSuperAdmin() ||
                    userRoles.includes('superAdmin') || 
                    realmRoles.includes('superAdmin') ||
                    keycloakInstance?.tokenParsed?.realm_access?.roles?.includes('superAdmin');

    // Check if user is partner admin
    const isPartnerAdmin = this.authService.isPartnerAdmin() ||
                    userRoles.includes('partnerAdmin') || 
                    realmRoles.includes('partnerAdmin') ||
                    keycloakInstance?.tokenParsed?.realm_access?.roles?.includes('partnerAdmin');

    // Check if user is admin using multiple methods
    const isAdmin = this.authService.isAdmin() || 
                    userRoles.includes('admin') || 
                    realmRoles.includes('admin') ||
                    keycloakInstance?.tokenParsed?.realm_access?.roles?.includes('admin');
    
    console.log('RoleRedirect - Final isSuperAdmin check:', isSuperAdmin);
    console.log('RoleRedirect - Final isPartnerAdmin check:', isPartnerAdmin);
    console.log('RoleRedirect - Final isAdmin check:', isAdmin);

    if (isSuperAdmin) {
      this.router.navigate(['/master/dashboard'], { replaceUrl: true });
    } else if (isPartnerAdmin || isAdmin) {
      this.router.navigate(['/admin/dashboard'], { replaceUrl: true });
    } else {
      // All other roles (companyAdmin, enterpriseAdmin, enterpriseAnalyst) go to enterprise dashboard
      this.router.navigate(['/enterprise/dashboard'], { replaceUrl: true });
    }
  }
}
